export default "__VITE_ASSET__5ca3abfb__"